import * as _ from "lodash";
import { HouseOccupant } from "./house-occupant.model";
import { House } from "./house.model";
import { User } from "./user.model";

export class Issue {
    public readonly requestIgnoreList = ["ModelsUtils"];

    private modelsUtils: any;
    public csqid: any = null;
    public csqdetails = "";
    public logs: any = [];
    public selected_contactmethods: any = [];
    public reminders: any = [];

    public houseoccupant: HouseOccupant;
    public assigned: User;

    public loading?: boolean;
    public status?: any;
    public house?: House;
    public csqasid?: string;
    public csqaassigned?: any;
    public origin?: any;
    public csqoid?: any;
    public csqoname?: any;
    public relevance?: any;

    constructor(ModelsUtils: any, issueData?: any) {
        this.modelsUtils = ModelsUtils;

        if (issueData) {
            this.setData(issueData);
        }
    }

    getID(): number {
        return this.csqid;
    }

    setData(issueData: object): void {
        this.logs = [];
        this.reminders = [];
        if (this.houseoccupant) {
            this.houseoccupant = this.modelsUtils.houseOccupant({
                selected_contactmethods: [],
            });
        }
        _.merge(this, issueData);
        this.assigned = this.modelsUtils.user(this.assigned);
    }
}
